import { Fragment, useEffect, useMemo, useState } from "react"
import { MainContainer } from "../../components"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { calculateTotalByKey, selectFilter } from "../../Utility/utility"

import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import jsPDF from "jspdf"
import { autoTable } from "jspdf-autotable"
import { useNavigate } from "react-router-dom"
import { setStockLotno } from "../../state/stockEntrySlice"
import { Chip } from "@heroui/react"
import { cond } from "lodash"
import { ConsoleView } from "react-device-detect"

const SinglePktLotWiseStock = () => {
  const { compCode, compName } = useSelector((state) => state.company);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data = [], mutate: filterData } = usePost({
    url: apiRoute.stockEntry.fetchLotWiseDetail,
    queryKey: "lotwiseDetailtck"
  });

  useEffect(() => {
    filterData({
      data: {
        comp_code: compCode.join(","),
        trade_of: "P",
        l_code: null,
        pkt_type: 'SNG'
      }
    });
  }, []);
  useEffect(() => {
    if (data && data.length > 0) {
      const d = data.filter((ele) =>ele.L_Code == '1072')// ele.L_Code == '1072' && ele.StkAt == 'KB SHAH'
      console.log(d, "fg")
    }
  }, [data])
  /* =======================
     BUILD DYNAMIC COLUMNS
     ======================= */
  const buildCategories = (data) => {
    const set = new Set();

    data.forEach(d => {
      if (!["Sale", "Inward", "Memo"].includes(d.StkAt)) {
        set.add(d.StkAt);
      }
    });

    const categories = Array.from(set);

    // Ensure Memo is always last
    if (data.some(d => d.StkAt === "Memo")) {
      categories.push("Memo");
    }

    return categories;
  };

  /* =======================
     FILTER EMPTY ROWS
     ======================= */
  const filterEmptyRows = (rows, dynamicCats) =>
    rows.filter(r => {
      const hasStock = dynamicCats.some(
        c => r[c].pcs > 0 || r[c].wt > 0
      );
      const hasTotal = r.Total.pcs > 0 || r.Total.wt > 0;
      return hasStock && hasTotal;
    });

  /* =======================
     FORMAT DATA
     ======================= */
  const formatLotSummary = (data) => {
    const dynamicCats = buildCategories(data);
    const lots = {};

    data.forEach(row => {
      const lot = row.L_Code;

      if (!lots[lot]) {
        lots[lot] = {
          lot,
          Memo: { pcs: 0, wt: 0 },
          Total: { pcs: 0, wt: 0 }
        };
        dynamicCats.forEach(c => {
          lots[lot][c] = { pcs: 0, wt: 0 };
        });
      }

      let key = null;
      if (!["Inward", "Sale"].includes(row.StkAt)) {
        key = row.StkAt;
      }

      if (key) {
        lots[lot][key].pcs += Number(row.Nos || 0);
        lots[lot][key].wt += Number(row.Weight || 0);

        lots[lot].Total.pcs += Number(row.Nos || 0);
        lots[lot].Total.wt += Number(row.Weight || 0);
      }
    });

    return { rows: Object.values(lots), dynamicCats };
  };


  /* =======================
     MEMOIZED DATA
     ======================= */
  const { rows: rawRows, dynamicCats } = useMemo(
    () => formatLotSummary(data),
    [data]
  );

  const rows = useMemo(
    () => filterEmptyRows(rawRows, dynamicCats),
    [rawRows, dynamicCats]
  );
  console.log(rows, "d")
  /* =======================
     FOOTER TOTALS
     ======================= */
  const footerTotal = useMemo(() => {
    const total = { Total: { pcs: 0, wt: 0 } };

    dynamicCats.forEach(c => {
      total[c] = { pcs: 0, wt: 0 };
    });

    rows.forEach(r => {
      dynamicCats.forEach(c => {
        total[c].pcs += r[c].pcs;
        total[c].wt += r[c].wt;
      });
      total.Total.pcs += r.Total.pcs;
      total.Total.wt += r.Total.wt;
    });

    return total;
  }, [rows, dynamicCats]);

  const handleDetail = (lotno) => {
    const obj = { filters: {}, lotnos: [String(lotno)], isInward: 0 }
    dispatch(setStockLotno(obj))
    navigate(linksUrl.rptSinglePktLotWiseStockDetail)

  }
  const commclass = "border border-gray-600 p-2 font-semibold"
  const tdclass = "border border-gray-300 p-1 leading-tight"
  const exportToExcel = async () => {
    if (!rows || rows.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Lot Stock Position");

    /* ================= REPORT TITLE & DATE ================= */
    const reportTitle = "Single Packet Lot Wise Stock Position"; // or dynamic
    const companyName = compName.join(","); // or dynamic
    const today = new Date().toLocaleDateString("en-GB");

    // Add title row
    const titleRow = worksheet.addRow([companyName]);
    worksheet.mergeCells(titleRow.number, 1, titleRow.number, 2 + dynamicCats.length * 2); // merge across all columns
    titleRow.font = { size: 14, bold: true };
    titleRow.alignment = { horizontal: "center", vertical: "middle" };

    // Add report name + date row
    const dateRow = worksheet.addRow([`${reportTitle} - (${today})`]);
    worksheet.mergeCells(dateRow.number, 1, dateRow.number, 2 + dynamicCats.length * 2);
    dateRow.font = { bold: true };
    dateRow.alignment = { horizontal: "center", vertical: "middle" };

    // Blank row after title
    worksheet.addRow([]);

    /* ================= HEADER ROWS ================= */
    const headerRow1 = ["Lot No"];
    dynamicCats.forEach(c => headerRow1.push(c, ""));
    headerRow1.push("Total", "");
    const headerRow2 = [""];
    dynamicCats.forEach(() => headerRow2.push("Pcs", "Weight"));
    headerRow2.push("Pcs", "Weight");

    const row1 = worksheet.addRow(headerRow1);
    const row2 = worksheet.addRow(headerRow2);

    /* Merge header cells for main categories */
    let colIndex = 2; // ExcelJS is 1-based, "Lot No" is first
    dynamicCats.forEach(() => {
      worksheet.mergeCells(row1.number, colIndex, row1.number, colIndex + 1);
      colIndex += 2;
    });
    worksheet.mergeCells(row1.number, colIndex, row1.number, colIndex + 1); // Total merge

    /* ================= STYLE HEADER ROWS ================= */
    const fullBorder = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    [row1, row2].forEach(row => {
      row.eachCell(cell => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = fullBorder;
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD3D3D3" } }; // light gray header
      });
    });

    /* ================= BODY ROWS ================= */
    rows.forEach(r => {
      const rowData = [r.lot];
      dynamicCats.forEach(c => {
        rowData.push(
          r[c].pcs || "",
          r[c].wt ? Number(r[c].wt.toFixed(2)) : ""
        );
      });
      rowData.push(
        r.Total.pcs,
        Number(r.Total.wt.toFixed(2))
      );

      const excelRow = worksheet.addRow(rowData);

      // Apply style to body
      excelRow.eachCell(cell => {
        cell.border = fullBorder;
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      // Optional: alternate row shading
      if (excelRow.number % 2 === 0) {
        excelRow.eachCell(cell => {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF2F2F2" } }; // light gray shade
        });
      }
    });

    /* ================= FOOTER ROW ================= */
    const footerData = ["Total"];
    dynamicCats.forEach(c => {
      footerData.push(
        footerTotal[c].pcs,
        Number(footerTotal[c].wt.toFixed(2))
      );
    });
    footerData.push(
      footerTotal.Total.pcs,
      Number(footerTotal.Total.wt.toFixed(2))
    );

    const footerRow = worksheet.addRow(footerData);

    footerRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = fullBorder;
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6E6FA" } }; // light lavender footer
    });

    /* ================= COLUMN WIDTH ================= */
    const colWidths = [{ wch: 12 }];
    dynamicCats.forEach(() => colWidths.push({ wch: 8 }, { wch: 12 }));
    colWidths.push({ wch: 8 }, { wch: 12 });
    worksheet.columns = colWidths;

    /* ================= SAVE FILE ================= */
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const timestamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15);
    saveAs(blob, `Single_Pkt_Lot_Wise_Stock_Position_${timestamp}.xlsx`);
  };

  const exportToPDF = () => {
    if (!rows || rows.length === 0) return;

    const doc = new jsPDF("p", "mm", "a4"); // landscape

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const companyName = compName.join(",") // 🔹 dynamic if needed
    const reportTitle = "SINGLE PACKET LOT WISE STOCK POSITION";
    const today = new Date().toLocaleDateString("en-GB");

    /* ================= HEADERS ================= */
    const headRow1 = [
      { content: "Lot No", rowSpan: 2 },
      ...dynamicCats.flatMap(c => [{ content: c, colSpan: 2 }]),
      { content: "Total", colSpan: 2 }
    ];

    const headRow2 = [
      ...dynamicCats.flatMap(() => [
        { content: "Pcs" },
        { content: "Weight" }
      ]),
      { content: "Pcs" },
      { content: "Weight" }
    ];

    /* ================= BODY ================= */
    const body = rows.map(r => ([
      r.lot,
      ...dynamicCats.flatMap(c => [
        r[c].pcs || "",
        r[c].wt ? r[c].wt.toFixed(2) : ""
      ]),
      r.Total.pcs,
      r.Total.wt.toFixed(2)
    ]));

    /* ================= FOOTER ================= */
    const foot = [[
      "Total",
      ...dynamicCats.flatMap(c => [
        footerTotal[c].pcs,
        footerTotal[c].wt.toFixed(2)
      ]),
      footerTotal.Total.pcs,
      footerTotal.Total.wt.toFixed(2)
    ]];

    /* ================= TABLE ================= */
    autoTable(doc, {
      startY: 20, // ⬅ space for repeating header
      head: [headRow1, headRow2],
      body,
      foot,
      theme: "grid",

      styles: {
        fontSize: 8,
        halign: "center",
        valign: "middle",
        lineWidth: 0.1
      },

      headStyles: {
        fillColor: [240, 240, 240],
        textColor: 0,
        fontStyle: "bold"
      },

      footStyles: {
        fillColor: [240, 240, 240],
        textColor: 0,
        fontStyle: "bold"
      },

      columnStyles: {
        0: { halign: "left", cellWidth: 22 }
      },

      margin: { left: 8, right: 8 },

      didDrawPage: (data) => {
        /* ===== HEADER (REPEATS EVERY PAGE) ===== */
        data.settings.margin.top = 20
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(companyName, pageWidth / 2, 10, { align: "center" });

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(reportTitle, pageWidth / 2, 16, { align: "center" });

        doc.setFontSize(9);
        doc.text(`Date : ${today}`, pageWidth - 15, 10, { align: "right" });

        /* ===== FOOTER ===== */
        doc.setFontSize(8);
        doc.text(
          `Generated on : ${new Date().toLocaleString()}`,
          pageWidth - 15,
          pageHeight - 5,
          { align: "right" }
        );
      }
    });

    doc.save("Single_Pkt_Lot_Wise_Stock_Position.pdf");
  };




  return (
    <MainContainer
      pageName="Single Packet Lot Wise Stock Position"
      breadcrumbs={["Reports", "Single Packet Lot Wise Stock Position"]}
    >
      <div className="bg-white p-2 h-screen">
        <div className="flex justify-end mb-2 gap-4">
          <button
            onClick={exportToExcel}
            className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
          >
            Export Excel
          </button>
          <button
            onClick={exportToPDF}
            className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-green-700"
          >
            Export PDF
          </button>
        </div>

        <div className="overflow-auto max-h-[70vh]">
          <table className="w-full  border-separate border-spacing-0  text-sm  text-center">

            <thead className="sticky top-0  border-1 border-slate-700   uppercase text-xs z-10">
              <tr className="bg-gradient-to-r from-slate-200 to-slate-50">
                <th rowSpan="2" className={commclass}>Lot No</th>
                {dynamicCats.map(c => (
                  <th key={c} colSpan="2" className={`${commclass} ${c=="MEMO"?' text-blgue-500':' text-regd-500'} `}>
                    {c} 
                  </th>
                ))}

                <th colSpan="2" className={commclass}>Total</th>
              </tr>

              <tr className={`${commclass} bg-white`}>
                {dynamicCats.map(c => (
                  <Fragment key={c} className="" >
                    <th className={`${commclass}`}>Pcs</th>
                    <th className={`${commclass} `}>Weight</th>
                  </Fragment>
                ))}
                <th className={commclass}>Pcs</th>
                <th className={commclass}>Weight</th>
              </tr>
            </thead>

            {/* ================= BODY ================= */}
            <tbody>
              {rows.map(r => (
                <tr key={r.lot} className="hover:bg-slate-100">
                  <td className={`${tdclass} border-r-2 border-gray-700`}>

                    <div >
                      <Chip onClick={() => handleDetail(r.lot)} className="  bg-yellow-50 text-rose-600  cursor-pointer p-2" variant="flat" color="dandger" >  {r.lot}  </Chip></div>
                  </td>

                  {dynamicCats.map(c => (
                    <Fragment key={c}>
                      <td className={tdclass}>{r[c].pcs || ""}</td>
                      <td className={`${tdclass} `}>
                        {r[c].wt ? r[c].wt.toFixed(2) : ""}
                      </td>
                    </Fragment>
                  ))}

                  <td className={`${tdclass}  text-rose-600 font-semibold`}>{r.Total.pcs}</td>
                  <td className={`${tdclass}  text-rose-600 font-semibold`}>
                    {r.Total.wt.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>

            {/* ================= FOOTER ================= */}
            <tfoot className="sticky bottom-0 bg-slate-200 font-semibold z-10">
              <tr>
                <td className={commclass}>Total</td>

                {dynamicCats.map(c => (
                  <Fragment key={c}>
                    <td className={commclass}>{footerTotal[c].pcs}</td>
                    <td className={commclass}>
                      {footerTotal[c].wt.toFixed(2)}
                    </td>
                  </Fragment>
                ))}

                <td className={`${commclass} text-rose-600 font-semibold`}>{footerTotal.Total.pcs}</td>
                <td className={`${commclass} text-rose-600 font-semibold`}>
                  {footerTotal.Total.wt.toFixed(2)}
                </td>
              </tr>
            </tfoot>

          </table>
        </div>
      </div>
    </MainContainer>
  );
};

export default SinglePktLotWiseStock;
